import { useState } from "react";
import {
  Network,
  Package,
  Truck,
  Store,
  BarChart3,
  ArrowUpRight,
} from "lucide-react";

const services = [
  {
    title: "Intermediación Comercial Estratégica",
    desc: "Conexión directa entre grandes fabricantes y redes de venta minoristas para optimizar costos de adquisición y ampliar mercados de consumo.",
    icon: Network,
  },
  {
    title: "Venta por Consignación Especializada",
    desc: "Colocación de inventario en puntos de venta estratégicos bajo esquemas flexibles que minimizan el riesgo financiero del comerciante final.",
    icon: Package,
  },
  {
    title: "Distribución Mayorista y Logística",
    desc: "Gestión de inventarios a gran escala, almacenamiento temporal y distribución capilar para asegurar el abasto permanente de mercancías.",
    icon: Truck,
  },
  {
    title: "Comercio al por Menor Directo",
    desc: "Operación de canales de venta directa al consumidor final, facilitando la validación inmediata de la aceptación de nuevos productos.",
    icon: Store,
  },
  {
    title: "Análisis de Desplazamiento y Merchandising",
    desc: "Servicio complementario de monitoreo de rotación de stock y exhibición en punto de venta para acelerar el ciclo de compra.",
    icon: BarChart3,
  },
];

const Servicios = () => {
  const [active, setActive] = useState(0);

  return (
    <section
      id="servicios"
      data-testid="servicios-section"
      className="bg-white text-black py-24 lg:py-32"
    >
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12">
        <div className="flex items-center gap-4 mb-12">
          <div className="h-px w-12 bg-[#C7343D]" />
          <span className="text-xs font-semibold tracking-[0.3em] uppercase text-[#C7343D]">
            Servicios
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
          <h2
            data-testid="servicios-heading"
            className="lg:col-span-9 font-display text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-light tracking-[-0.03em] leading-[1] text-black text-balance"
          >
            Soluciones eficientes,
            <span className="italic font-extralight text-[#595959]">
              {" "}
              personalizadas{" "}
            </span>
            y a la medida de cada cliente.
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* List */}
          <div className="lg:col-span-8 border-t border-black/10">
            {services.map((s, i) => {
              const Icon = s.icon;
              const isActive = active === i;
              return (
                <div
                  key={s.title}
                  data-testid={`service-row-${i}`}
                  onMouseEnter={() => setActive(i)}
                  onClick={() => setActive(i)}
                  className="service-row group border-b border-black/10 py-8 lg:py-10 cursor-pointer"
                >
                  <div className="flex items-center justify-between gap-6">
                    <div className="flex items-center gap-6 flex-1">
                      <ArrowUpRight
                        className={`arrow ${isActive ? "text-[#C7343D]" : "text-black"}`}
                        size={28}
                      />
                      <h3
                        className={`font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight font-normal transition-colors ${
                          isActive ? "text-[#C7343D]" : "text-black"
                        }`}
                      >
                        {s.title}
                      </h3>
                    </div>
                    <span className="numeric text-[#595959] text-sm tracking-widest">
                      0{i + 1}
                    </span>
                  </div>
                  <div
                    className={`overflow-hidden transition-all duration-500 ${
                      isActive ? "max-h-40 mt-4" : "max-h-0"
                    }`}
                  >
                    <p className="text-[#595959] text-base lg:text-lg leading-relaxed max-w-2xl pl-0 lg:pl-12">
                      {s.desc}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Detail panel */}
          <div className="lg:col-span-4">
            <div className="sticky top-28 bg-black text-white p-10 lg:p-12 min-h-[400px] flex flex-col justify-between">
              <div>
                <div className="flex items-center gap-3 mb-8">
                  <div className="h-px w-8 bg-[#F3901A]" />
                  <span className="text-xs tracking-[0.3em] uppercase text-[#F3901A] font-semibold">
                    Servicio · 0{active + 1}
                  </span>
                </div>
                {(() => {
                  const Icon = services[active].icon;
                  return (
                    <Icon
                      size={56}
                      strokeWidth={1.25}
                      className="text-white mb-8"
                    />
                  );
                })()}
                <h4 className="font-display text-2xl lg:text-3xl font-light tracking-tight text-white leading-tight">
                  {services[active].title}
                </h4>
                <p className="mt-4 text-white/70 leading-relaxed text-sm">
                  {services[active].desc}
                </p>
              </div>
              <div className="mt-10 text-xs uppercase tracking-[0.3em] text-white/40">
                ¡Conócenos y hagamos equipo!
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Servicios;
